import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "datatables.net-bs4";
import moment from "moment-timezone";
import {Link, useLocation} from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs4";
import {Button, Dropdown} from "react-bootstrap";
import {FiFilter} from "react-icons/fi";
import {MdEditCalendar} from "react-icons/md";
import {DateRangePicker} from "react-bootstrap-daterangepicker";

import {UserContext} from "../../App";
import {useBookings} from "../../utils/booking";
import {
  deleteBooking,
  duplicateBooking,
  unsetBookingsDriver,
  updateBooking,
} from "../../utils/booking/api";
import { publishOffersToDrivers } from "../../utils/driverApp/adminApi";

import SelectDriverModal from "../../utils/booking/SelectDriverModal";
import FiltersModal from "../../utils/booking/FiltersModal";

import {
  bookingProgressStatusList,
} from "../driverApp/content/trackContent";
import {
  createEstimateFromBookingIdList,
  createInvoiceFromBookingIdList,
} from "../../store/actions/estimateActions";
import {apiRoot} from "../../index";
import md5 from "md5";
import {useFolder} from "../../utils/folder";
import {estimateStatus} from "./estimateContent";
import {invoiceStatus} from "./invoiceContent";
import {isExternal, verifyRight} from "../../utils/users";
import styled from "styled-components";
import SelectionActionsPopup from "../layout/SelectionActionsPopup";
import WhatsappIcon from "../icons/WhatsappIcon";
import TrashIcon from "../icons/TrashIcon";
import ActionsMenu from "../layout/ActionsMenu";
import {OutlineButton, OutlineButtonLink} from "../layout/OutlineButton";
import {zoneOf, PARIS, UNCLASSIFIED} from "../../utils/booking/zones";
import {stopLoading} from "../../utils/loader";

// « À PRÉVOIR » (demande Sylvain 30/09/2026) : mots-clés de la note chauffeur
// (siège enfant, animal, mobilité, bagages hors norme, attente) → une ligne
// déterministe dans le texte copié pour le chauffeur. Mots-clés seuls, sans
// extrait de la note. Ajouter un besoin = ajouter une entrée ici.
const DRIVER_NEEDS = [
  { label: "siège enfant", re: /si[èe]ges?\s*(b[ée]b[ée]|enfant|auto)|r[ée]hausseurs?|baby\s*seats?|child\s*seats?|infant\s*seats?|car\s*seats?|boosters?|toddler/i, count: true },
  { label: "chien", re: /\bchiens?\b|\bdogs?\b|chihuahua|labrador|bulldog|caniche|puppy/i },
  { label: "chat", re: /\bchats?\b|\bcats?\b|kitten/i },
  { label: "animal", re: /\banimaux?\b|\bpets?\b|animal de compagnie/i },
  { label: "fauteuil roulant", re: /fauteuils?\s*roulants?|wheel\s*chairs?|\bPMR\b|mobilit[ée] r[ée]duite|reduced mobility|walker\b|d[ée]ambulateur/i },
  { label: "poussette", re: /poussettes?|strollers?|pushchairs?|prams?/i },
  { label: "vélo", re: /\bv[ée]los?\b|\bbikes?\b|bicycles?/i },
  { label: "skis", re: /\bskis?\b|snowboards?/i },
  { label: "golf", re: /\bgolf\b/i },
  { label: "surf", re: /\bsurf(board)?s?\b/i },
  { label: "attente possible", re: /attendre|attente|patient(e|er)|waiting|may (be|run) late|se termine (vers|à|entre)|ends? (at|around|between)/i },
];
export function driverNeedsFromNote(note) {
  const text = String(note || "");
  const found = [];
  for (const need of DRIVER_NEEDS) {
    const m = text.match(need.re);
    if (!m) continue;
    let label = need.label;
    if (need.count) {
      // « 2 sièges enfant », « two child seats » → nombre repris si > 1.
      const before = text.slice(Math.max(0, m.index - 12), m.index);
      const n = before.match(/(\d+|deux|trois|two|three)\s*$/i);
      const map = { deux: 2, two: 2, trois: 3, three: 3 };
      const num = n ? (map[n[1].toLowerCase()] || parseInt(n[1], 10)) : 0;
      if (num > 1) label = num + " sièges enfant";
    }
    found.push(label);
  }
  // « chien » ou « chat » rendent « animal » redondant.
  const out = found.filter((l) => !(l === "animal" && (found.includes("chien") || found.includes("chat"))));
  // Jamais de montant dans ce texte (règle 24/09) : les libellés sont fixes, on vérifie par sécurité.
  return out.filter((l) => !/€|\beur\b|euros?/i.test(l));
}

let vehiclePossibleValues = {
  meetngreet: ["meetngreet", "Meet and greet"],
  berline: [
    "berline",
    "Class E",
    "E Class",
    "Klasse E",
    "E Klasse",
    "Classe E",
    "E Classe",
    "Clase E",
    "E Clase",
  ],
  van: [
    "van",
    "Class V",
    "V Class",
    "Klasse V",
    "V Klasse",
    "Classe V",
    "V Classe",
    "Clase V",
    "V Clase",
  ],
  eco: ["eco"],
  moto: ["moto"],
  first:
    /first|Class S|[^e]S Class|Klasse S|[^e]S Klasse|Classe S|[^e]S Classe|Clase S|[^e]S Clase/i,
  minibus: ["minibus", "sprinter"],
  bus: ["bus"],
};

export const StyledTr = styled.tr`
    &.checked td {
        box-shadow: inset 0 0 0 9999px rgba(var(--dt-row-hover), 0.075);
    }

    &.urgent td {
        background-color: #fee;
    }
`;

export default function BookingContent() {
  const {userInfos} = useContext(UserContext);
  const [checked, setChecked] = useState([]);
  const datatable = useRef(null);
  const location = useLocation();

  const folderId = useMemo(() => {
    let searchParams = new URLSearchParams(location.search);
    return searchParams.get("folder_id");
  }, [location.search]);

  const {folder} = useFolder(folderId);

  const [dateRange, setDateRange] = useState({
    startDate: moment().subtract(7, "days").startOf("day"),
    endDate: moment().add(3, "months").endOf("day"),
  });

  const {bookings, loaded} = useBookings(
    dateRange.startDate,
    dateRange.endDate,
    true,
    folderId
  );

  const [showSelectDriverModal, setShowSelectDriverModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isUpdatingDriver, setIsUpdatingDriver] = useState(false);

  const [showFiltersModal, setShowFiltersModal] = useState(false);
  const [filters, setFilters] = useState({
    vehicle: "",
    provider: "",
  });
  const isCreatingInvoiceFromFolderRef = useRef(false);

  function handleCalendar(event, picker) {
    setDateRange({
      startDate: picker.startDate.startOf("day"),
      endDate: picker.endDate.endOf("day"),
    });

    // region trick to delete jquery datatable dom before React Shadow DOM update
    if (datatable.current) {
      datatable.current.destroy();
      datatable.current = null;
    }
    // endregion
  }

  // update filters
  const updateFilters = useCallback(() => {
    if (!datatable.current) return;

    const {vehicle, provider} = filters;

    if (provider) datatable.current.column(6).search(provider || "");
    let vehicleReg = "";
    if (vehicle) {
      if (Array.isArray(vehiclePossibleValues[vehicle])) {
        vehicleReg = vehiclePossibleValues[vehicle].join("|");
        datatable.current.column(9).search(vehicleReg || "", true, false);
      } else {
        vehicleReg = vehiclePossibleValues[vehicle];
        datatable.current.column(9).search(vehicleReg);
      }
    }

    datatable.current.draw();
  }, [filters]);

  useEffect(() => {
    updateFilters();
  }, [filters, updateFilters]);

  // update datatable content
  useEffect(() => {
    if (!loaded) return;

    if (datatable.current) {
      datatable.current.destroy();
      datatable.current = null;
    }

    window.setTimeout(
      () => {
        datatable.current = $("#datatable").DataTable({
          retrieve: true,
          order: [[4, "asc"]],
          pageLength: 50,
          language: {
            lengthMenu: "Afficher _MENU_ lignes",
            entries: {
              _: "courses",
              1: "course",
            },
            info: "Affichage de _START_ à _END_ _ENTRIES-TOTAL_ sur un total de _TOTAL_ _ENTRIES-TOTAL_",
          },
        });

        $("#datatable").on("draw.dt", function (e, dt) {
          let order = dt.aaSorting;

          let lastPickupDate = null;

          $("#datatable tr").each(function () {
            let tr = $(this);
            let pickup_date = moment(1000 * parseInt(tr.attr("pickup-time")));

            $(this)
              .find("td")
              .each(function () {
                if (
                  order &&
                  order.length === 1 &&
                  order[0] &&
                  order[0][0] === 4 &&
                  order[0][1] === "asc" &&
                  pickup_date.isValid() &&
                  lastPickupDate &&
                  !lastPickupDate.isSame(pickup_date, "day")
                ) {
                  $(this).css("border-top", "2px solid black");
                } else {
                  $(this).css("border-top", "none");
                }
              });

            if (pickup_date.isValid()) lastPickupDate = pickup_date;
          });
        });

        updateFilters();
      },
      1,
      {
        flush: true,
      }
    );
  }, [bookings, loaded, updateFilters]);

  function handleCheckbox(e) {
    const {value, checked: isChecked} = e.target;

    if (isChecked) {
      setChecked((old) => [...old, String(value)]);
    } else {
      setChecked((old) => old.filter((id) => id !== String(value)));
    }
  }

  function handleEditDriverModal(booking) {
    setSelectedBooking(booking);
    setShowSelectDriverModal(true);
  }

  async function updateDriverFromModal(driver) {
    setIsUpdatingDriver(true);
    try {
      await updateBooking(userInfos.jwt, {
        id: selectedBooking.id,
        driver,
      });
    } catch (e) {
      window.alert("Erreur lors de l'attribution du chauffeur : " + e.response.data);
    }
    setShowSelectDriverModal(false);
    setIsUpdatingDriver(false);
    window.location.reload();
  }

  const buildDriverInfos = useCallback(
    (bookingIdList) => {
      let msg = "";

      for (let i = 0; i < bookingIdList.length; i++) {
        const booking = bookings.find((b) => String(b.id) === String(bookingIdList[i]));

        // region pickup date format
        let pickup_date = "";

        if (booking.pickup_date.moment.isSame(moment(), "day")) {
          pickup_date = "Aujourd'hui ";
        } else if (
          booking.pickup_date.moment.isSame(moment().add(1, "day"), "day")
        ) {
          pickup_date = "Demain ";
        }

        pickup_date += booking.pickup_date.date;
        // endregion

        msg += "Course No." + (i + 1) + "\n";
        msg += "*" + pickup_date + "*\n";
        msg += "*PICK UP : " + booking.pickup_address + "*\n";
        msg += "DROP OFF : " + booking.dropoff_address + "\n";
        msg += "*VEHICLE : " + booking.vehicle + "*\n";
        // Numéro de vol / train : le chauffeur suit l'atterrissage (demande Sylvain 30/09/2026).
        const flightNo = String(booking.flight_number || "").trim();
        if (flightNo) msg += "*VOL / TRAIN : " + flightNo + "*\n";
        // Paire Meet & Greet : la voiture porte le suffixe T, le greeter l'id nu.
        // Mention seule, sans nom ni téléphone du greeter (choix Sylvain 30/09/2026).
        const isGreeter = String(booking.vehicle || "").toLowerCase() === "meetngreet";
        const twinId = isGreeter ? String(booking.id) + "T" : String(booking.id).replace(/T$/i, "");
        const twin = twinId !== String(booking.id) ? bookings.find((b) => String(b.id) === twinId) : null;
        if (isGreeter) {
          if (twin) msg += "*VOITURE : course " + twin.id + " (" + (twin.vehicle || "") + ")*\n";
        } else if ((twin && String(twin.vehicle || "").toLowerCase() === "meetngreet") || /greeter/i.test(booking.additional_info || "")) {
          msg += "*AVEC GREETER*\n";
        }
        const needs = driverNeedsFromNote(booking.additional_info);
        if (needs.length) msg += "*À PRÉVOIR : " + needs.join(", ") + "*\n";
        msg += "PRICE : \u20ac" + booking.driver_price + " (en compte)\n";
        msg +=
          apiRoot +
          "/confirmation/" +
          userInfos.uid +
          "/" +
          bookingIdList[i] +
          "/" +
          md5((booking.firstname || "") + " " + (booking.lastname || "")) +
          "\n";
        msg += "Ouvrir le lien pour accepter la course";
        msg += "\n\n";
      }
      return msg;
    },
    [bookings, userInfos]
  );

  const alertInfosToDriver = useCallback(
    async (bookingIdList) => {
      if (!bookingIdList.length) return;
      await navigator.clipboard.writeText(buildDriverInfos(bookingIdList));
      window.alert("Informations copiées dans le presse-papiers");
    },
    [buildDriverInfos]
  );

  // « Dispatch demain » (demande Sylvain 30/09/2026) : courses de DEMAIN sans
  // chauffeur, par type de véhicule (first et minibus à part), cochées dans la
  // liste et copiées d'un coup pour les groupes WhatsApp. Pas de M&G (greeter),
  // pas de course partagée par un partenaire. Triées par heure.
  const DISPATCH_CATEGORIES = useMemo(() => [
    { key: "berline", label: "Berline", vehicles: ["berline"] },
    { key: "van", label: "Van", vehicles: ["van"] },
    { key: "first", label: "Classe S", vehicles: ["first"] },
    { key: "minibus", label: "Minibus", vehicles: ["minibus"] },
    { key: "all", label: "Toutes Paris", vehicles: null },
  ], []);
  const dispatchTomorrow = useMemo(() => {
    const tomorrow = moment().add(1, "day");
    return bookings
      .filter((b) =>
        b?.pickup_date?.moment?.isSame(tomorrow, "day") &&
        !(b.driver && b.driver.name) &&
        !b.sharedBy &&
        String(b.vehicle || "").toLowerCase() !== "meetngreet"
      )
      .map((b) => ({ booking: b, zone: zoneOf(b) }))
      .sort((a, b) => String(a.booking.time || "").localeCompare(String(b.booking.time || "")));
  }, [bookings]);
  // Paris : par type de véhicule (groupes WhatsApp). Province : une ligne par
  // zone, tous véhicules (prestataire unique). « À classer » : zone inconnue.
  const dispatchParis = useMemo(() => dispatchTomorrow.filter((x) => x.zone.key === PARIS.key).map((x) => x.booking), [dispatchTomorrow]);
  const dispatchProvince = useMemo(() => {
    const byZone = new Map();
    for (const x of dispatchTomorrow) {
      if (x.zone.key === PARIS.key) continue;
      if (!byZone.has(x.zone.key)) byZone.set(x.zone.key, { zone: x.zone, list: [] });
      byZone.get(x.zone.key).list.push(x.booking);
    }
    const arr = [...byZone.values()];
    // « À classer » toujours en dernier, le reste par nom
    return arr.sort((a, b) => (a.zone.key === UNCLASSIFIED.key) - (b.zone.key === UNCLASSIFIED.key) || a.zone.label.localeCompare(b.zone.label));
  }, [dispatchTomorrow]);
  const dispatchListFor = useCallback(
    (cat) => dispatchParis.filter((b) => !cat.vehicles || cat.vehicles.includes(String(b.vehicle || "").toLowerCase())),
    [dispatchParis]
  );
  const dispatchCopy = useCallback(
    async (label, list, header) => {
      const when = moment().add(1, "day").format("DD/MM");
      if (!list.length) {
        window.alert(`Aucune course ${label} sans chauffeur demain (${when}).`);
        return;
      }
      const ids = list.map((b) => String(b.id));
      setChecked(ids);
      await navigator.clipboard.writeText((header ? header + "\n\n" : "") + buildDriverInfos(ids));
      window.alert(`${ids.length} course${ids.length > 1 ? "s" : ""} ${label} de demain (${when}) sans chauffeur : sélectionnée${ids.length > 1 ? "s" : ""} et copiée${ids.length > 1 ? "s" : ""} dans le presse-papiers.`);
    },
    [buildDriverInfos]
  );

  // Espace chauffeur : propose les courses sélectionnées dans l'app (push +
  // onglet « Proposées »). Audience = type de véhicule saisi, vide = tous.
  const proposeToDriverApp = useCallback(
    async (bookingIdList) => {
      if (!bookingIdList.length) return;
      const first = bookings.find((b) => String(b.id) === String(bookingIdList[0]));
      const vehicleInput = window.prompt(
        "Proposer aux chauffeurs de l'espace chauffeur.\n" +
          "Type de véhicule ciblé (vide = tous les chauffeurs) :",
        bookingIdList.length === 1 && first ? first.vehicle || "" : ""
      );
      if (vehicleInput === null) return;
      const vehicle = vehicleInput.trim();
      const audience = vehicle ? { vehicleTypes: [vehicle] } : { all: true };
      try {
        const r = await publishOffersToDrivers(userInfos.jwt, bookingIdList, audience);
        const results = (r && r.results) || [];
        const ok = results.filter((x) => x.status === 200);
        const ko = results.filter((x) => x.status !== 200);
        const notified = ok.reduce((n, x) => n + (x.notified || 0), 0);
        window.alert(
          `${ok.length} course(s) proposée(s) dans l'espace chauffeur` +
            (notified ? ` — ${notified} notification(s) push envoyée(s)` : "") +
            (ko.length ? `\nNon proposées : ${ko.map((x) => `${x.bookingId} (${x.error})`).join(", ")}` : "")
        );
      } catch (e) {
        window.alert("Erreur lors de la proposition aux chauffeurs : " + (e.response?.data?.error || e.response?.data || e.message));
      }
    },
    [bookings, userInfos]
  );

  const alertBookingsDetails = useCallback(
    async (bookingIdList) => {
      if (!bookingIdList.length) return;
      let msg = "";

      for (let i = 0; i < bookingIdList.length; i++) {
        const booking = bookings.find((b) => String(b.id) === String(bookingIdList[i]));
        msg += "Course No." + (i + 1) + "\n";
        msg += "Name : " + booking.firstname + " " + booking.lastname + "\n";
        msg += "Passengers : " + booking.passengers + "\n";
        msg += "Bags : " + booking.bags + "\n";
        msg += "Vehicle : " + booking.vehicle + "\n";
        msg += "Trip Type : " + booking.type + "\n";
        msg +=
          "Pickup Time : " +
          booking.pickup_date.moment.format("DD/MM/YYYY") +
          " at " +
          booking.time +
          "\n";
        msg += "Pickup Address : " + booking.pickup_address + "\n";
        msg += "Full Pickup Address : " + booking.pickup.full_address + "\n";
        msg += "Dropoff Address : " + booking.dropoff_address + "\n";
        msg += "Full Dropoff Address : " + booking.dropoff.full_address + "\n";
        msg += "Informations : " + booking.additional_info + "\n";
        msg += "Flight Number : " + booking.flight_number + "\n";
        msg +=
          "Phone Number : " + (booking.hide_phone ? "" : booking.phone) + "\n";
        msg += "Company : ";
        msg += (booking?.driver?.company?.name || "") + "\n";
        msg += "Driver : ";
        msg += (booking?.driver?.name || "") + "\n\n\n";
      }

      await navigator.clipboard.writeText(msg);
      window.alert("Details copiés dans le presse-papiers");
    },
    [bookings]
  );

  const datatableContent = useMemo(() => {
    return bookings.map((booking, i) => {
      // region row class

      let rowClass = "";

      let urgent =
        booking.pickup_date.sortDate === -1 ||
        booking.pickup_date.sortDate === -2;

      if (urgent) {
        rowClass += "urgent ";
      }
      if (checked.some((id) => id === String(booking.id))) {
        rowClass += "checked ";
      }

      // endregion

      // region actions
      let actions = [];
      if (verifyRight(userInfos, "booking", "update"))
        actions.push({
          label: "Modifier",
          link: `/booking/${booking.id}`,
        });

      if (verifyRight(userInfos, "booking", "delete"))
        actions.push({
          label: "Supprimer",
          onClick: async () => {
            if (
              !window.confirm("Voulez-vous vraiment supprimer cette course ?")
            )
              return;

            try {
              await deleteBooking(userInfos.jwt, booking.id);
            } catch (e) {
              window.alert(
                "Erreur lors de la suppression : " + e.response.data
              );
              stopLoading();
              return;
            }
            window.location.reload();
          },
          disabled: !!booking.sharedBy,
        });

      if (verifyRight(userInfos, "booking", "create"))
        actions.push({
          label: "Dupliquer",
          onClick: async () => {
            try {
              await duplicateBooking(userInfos.jwt, booking.id);
            } catch (e) {
              window.alert("Erreur lors de la duplication : " + e.response.data);
              stopLoading();
              return;
            }
            window.location.reload();
          },
          disabled: !!booking.sharedBy,
        });

      if (verifyRight(userInfos, "booking", "update"))
        actions.push({
          label: "Supprimer le chauffeur",
          onClick: async () => {
            try {
              await unsetBookingsDriver(userInfos.jwt, booking.id);
            } catch (e) {
              window.alert("Erreur lors de la suppression du chauffeur : " + e.response.data);
              stopLoading();
              return;
            }
            window.location.reload();
          },
          disabled: !!booking.sharedBy,
        });

      if (verifyRight(userInfos, "invoice", "create"))
        actions.push({
          label: "Créer une facture",
          onClick: async () => {
            try {
              await createInvoiceFromBookingIdList(userInfos, [booking.id]);
              window.alert("Invoice created");
              window.location.reload();
            } catch (e) {
              console.error(e);
              window.alert("Error creating invoice");
            }
          },
          disabled: !!booking.sharedBy,
        });

      actions.push({divider: true});
      actions.push({
        label: "Copier les informations pour le chauffeur",
        onClick: () => alertInfosToDriver([booking.id]),
      });
      actions.push({
        label: "Copier le bon de mission",
        onClick: () => alertBookingsDetails([booking.id]),
      });
      if (verifyRight(userInfos, "booking", "update"))
        actions.push({
          label: "Proposer dans l'espace chauffeur",
          onClick: () => proposeToDriverApp([booking.id]),
          disabled: !!booking.sharedBy || !!booking.driverId,
        });

      // endregion

      return (
        <StyledTr
          className={rowClass}
          key={i}
          pickup-time={booking.pickup_date.moment.unix()}
        >
          <td style={{textAlign: "center"}}>
            <input
              type="checkbox"
              checked={checked.some((id) => id === String(booking.id))}
              name="bulk_action"
              value={booking.id}
              onChange={handleCheckbox}
            />
          </td>
          <td data-order={booking.id}>
            {booking.folder_id ? (
              <a
                href={`/?folder_id=${booking.folder_id}`}
              >{`[${booking.folder_id}] ${booking.id}`}</a>
            ) : (
              booking.id
            )}
          </td>
          <td>
            {booking?.driver?.name}
            {booking?.driver_phone && (
              <>
                <br/>
                <em>({booking.driver_phone})</em>
                <br/>
              </>
            )}
            {booking.driver && booking.macaron_number && (
              <>
                <div className="d-inline-block rounded-circle bg-dark text-white p-2">
                  {booking.macaron_number}
                </div>
                <br/>
              </>
            )}
            {!booking?.sharedBy && verifyRight(userInfos, "booking", "update") && !isExternal(userInfos) && (
              <>
                {booking?.driver?.name ? (
                  <button
                    onClick={() => handleEditDriverModal(booking)}
                    style={{
                      padding: "0",
                      display: "inline-block",
                      border: "none",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "transparent",
                    }}
                    className="icon icon-pencil"
                  ></button>
                ) : (
                  <Button
                    variant="outline-primary"
                    onClick={() => handleEditDriverModal(booking)}
                    style={{borderRadius: "50%", padding: "5px 10px"}}
                  >
                    +
                  </Button>
                )}
              </>
            )}
          </td>
          <td>
            {(booking.progress_status || booking.driverUrgent) && (
              <div
                className={`d-inline-block rounded p-2 ${
                  booking.driverUrgent ? "text-white bg-danger" : ""
                }`}
              >
                {booking.driverUrgent
                  ? "Contacter le chauffeur"
                  : bookingProgressStatusList[booking.progress_status || 0]}
              </div>
            )}
          </td>
          <td data-order={booking.pickup_date.sortDate}>
            {booking.pickup_date.date}
          </td>
          <td>{booking.name}</td>
          <td>{booking?.provider?.name || ""}</td>
          <td>
            {(() => { const z = zoneOf(booking); return z.key !== PARIS.key ? <span className={`badge ${z.key === UNCLASSIFIED.key ? "bg-warning text-dark" : "bg-light text-dark border"} mr-1`} title="Zone de dispatch">{z.label}</span> : null; })()}
            {booking.pickup_address}
          </td>
          <td>{booking.dropoff_address}</td>
          <td>{booking.vehicle}</td>
          {verifyRight(userInfos, "client_price", "read") && (
            <td>{booking.amount}</td>
          )}
          {verifyRight(userInfos, "driver_price", "read") && (
            <td>{booking.driver_price}</td>
          )}
          <td data-order={booking.urgent ? -2 : booking.created_at}>
            {moment(booking.created_at).format("DD MMM YYYY HH:mm")}
          </td>
          <td>
            {booking.estimate_id && (
              <Link
                to={`/estimates/${booking.estimate_id}`}
                style={{whiteSpace: "nowrap"}}
              >
                Devis n°{booking.estimate_id}
              </Link>
            )}
            <br/>
            {booking.invoice_id && (
              <Link
                to={`/invoices/${booking.invoice_id}`}
                style={{whiteSpace: "nowrap"}}
              >
                Facture n°{booking.invoice_id}
              </Link>
            )}
          </td>
          <td>
            <ActionsMenu items={actions}/>
          </td>
        </StyledTr>
      );
    });
  }, [alertBookingsDetails, alertInfosToDriver, proposeToDriverApp, bookings, checked, userInfos]);

  const PortletFooter = useMemo(() => {
    if (checked.length) {
      const hasSharedBooking = checked.some((id) => {
        const booking = bookings.find((b) => String(b.id) === id);
        return booking?.sharedBy;
      });

      let buttons = [
        {
          label: <WhatsappIcon/>,
          onClick: () => alertInfosToDriver(checked),
          title: "Copier les informations pour le chauffeur",
        },
      ];

      if (verifyRight(userInfos, "booking", "delete"))
        buttons.push({
          label: <TrashIcon/>,
          onClick: async () => {
            if (!window.confirm("Voulez-vous vraiment supprimer ces courses ?"))
              return;
            try {
              await deleteBooking(userInfos.jwt, checked);
            } catch (e) {
              window.alert(
                "Erreur lors de la suppression d'un ou plusieurs booking : " + e.response.data
              );
              stopLoading();
            }
            window.location.reload();
          },
          disabled: hasSharedBooking,
          title: "Supprimer",
        });

      let items = [
        {
          label: "Copier le bon de mission",
          onClick: () => alertBookingsDetails(checked),
        },
      ];

      if (verifyRight(userInfos, "booking", "update"))
        items.push({
          label: "Proposer dans l'espace chauffeur",
          onClick: () => proposeToDriverApp(checked),
          disabled: hasSharedBooking,
        });

      if (verifyRight(userInfos, "booking", "update"))
        items.push({
          label: "Retirer le chauffeur",
          onClick: async () => {
            try {
              await unsetBookingsDriver(userInfos.jwt, checked);
            } catch (e) {
              window.alert("Erreur lors de la suppression du chauffeur d'un ou plusieurs bookings : " + e.response.data);
              stopLoading();
            }
            window.location.reload();
          },
          disabled: hasSharedBooking,
        });
      if (verifyRight(userInfos, "invoice", "create")) {
        // Check if all selected bookings have the same provider
        const selectedBookings = bookings.filter(b => checked.some((id) => id === String(b.id)));
        const providers = selectedBookings.map(b => b.provider?.id).filter(id => id);
        const uniqueProviders = [...new Set(providers)];
        const hasDifferentProviders = uniqueProviders.length > 1;
        
        items.push({
          label: "Générer une facture",
          onClick: async () => {
            try {
              await createInvoiceFromBookingIdList(userInfos, checked);
              window.alert("Facture créée");
              window.location.reload();
            } catch (e) {
              console.error(e);
              window.alert("Erreur lors de la création");
            }
          },
          disabled: hasDifferentProviders,
        });
      }
      if (verifyRight(userInfos, "booking", "create"))
        items.push({
          label: "Dupliquer la sélection",
          onClick: async () => {
            try {
              await duplicateBooking(userInfos.jwt, checked);
            } catch (e) {
              window.alert("Erreur lors de la duplication d'un ou certains bookings : " + e.response.data);
            }
            window.location.reload();
          },
          disabled: hasSharedBooking,
        });

      return (
        <SelectionActionsPopup
          selectedItemsLength={checked.length}
          resetChecked={() => setChecked([])}
          buttons={buttons}
          items={items}
        />
      );
    }
  }, [alertBookingsDetails, alertInfosToDriver, proposeToDriverApp, bookings, checked, userInfos]);

  const FolderFooter = useMemo(() => {
    return (
      <div className="d-flex gap-1">
        {!folder?.estimate_id &&
          !folder?.invoice_id &&
          !folder?.sharedBy &&
          verifyRight(userInfos, "estimate", "create") && (
            <button
              className="btn btn-primary"
              onClick={async () => {
                if (
                  !window.confirm(
                    "Êtes-vous sûr de vouloir créer un devis pour ce dossier ?"
                  )
                )
                  return;
                await createEstimateFromBookingIdList(
                  userInfos,
                  null,
                  folderId
                );
                window.alert("Devis créé");
                window.location.reload();
              }}
            >
              Créer un devis pour ce dossier
            </button>
          )}
        {!folder?.invoice_id &&
          folder?.estimate_id !== "accepted" &&
          verifyRight(userInfos, "invoice", "create") && (
            <button
              className="btn btn-primary"
              onClick={async () => {
                if (isCreatingInvoiceFromFolderRef.current) return;
                if (
                  !window.confirm(
                    "Êtes-vous sûr de vouloir créer une facture pour ce dossier ?"
                  )
                )
                  return;
                isCreatingInvoiceFromFolderRef.current = true;
                try {
                  await createInvoiceFromBookingIdList(userInfos, null, folderId);
                  window.alert("Facture créée");
                  window.location.reload();
                } catch (e) {
                  const msg =
                    e?.response?.data ||
                    e?.message ||
                    "Erreur lors de la création de la facture.";
                  window.alert(typeof msg === "string" ? msg : JSON.stringify(msg));
                } finally {
                  isCreatingInvoiceFromFolderRef.current = false;
                }
              }}
            >
              Créer une facture pour ce dossier
            </button>
          )}
      </div>
    );
  }, [
    folder?.estimate_id,
    folder?.invoice_id,
    folder?.sharedBy,
    folderId,
    userInfos,
  ]);

  if (!loaded) {
    return (
      <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
          <div className="">
            <div className="kt-portlet__body">
              <div className="text-center">Chargement...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="body-container">
      <div className="title-container">
        <h3 className="title">
          Courses
          {folder?.name ? ` du dossier "${folderId} - ${folder.name}"` : ""}
        </h3>
        <div className="header-toolbar">
          {!folderId && (
            <DateRangePicker
              initialSettings={{
                startDate: dateRange.startDate.format("DD/MM/YYYY"),
                endDate: dateRange.endDate.format("DD/MM/YYYY"),
              }}
              onApply={handleCalendar}
            >
              <button
                type="button"
                className="btn kt-subheader__btn-daterange"
                data-toggle="kt-tooltip"
                title="Select dashboard daterange"
                data-placement="left"
              >
                <span
                  className="kt-subheader__btn-daterange-date mr-2"
                  id="kt_dashboard_daterangepicker_date"
                >
                  {dateRange.startDate.format("DD/MM/YYYY") +
                    " - " +
                    dateRange.endDate.format("DD/MM/YYYY")}
                </span>

                <MdEditCalendar size={24}/>
              </button>
            </DateRangePicker>
          )}
          <button
            onClick={() => setShowFiltersModal(true)}
            className="btn-custom"
          >
            <FiFilter size={24}/>
          </button>
          {!folderId && (
            <Dropdown className="d-inline-block mr-2">
              <Dropdown.Toggle as={OutlineButton} id="dispatch-tomorrow" title="Sélectionner et copier les courses de demain sans chauffeur">
                <i className="la la-copy"></i>Dispatch demain ({dispatchTomorrow.length})
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Header>Paris ({dispatchParis.length})</Dropdown.Header>
                {DISPATCH_CATEGORIES.map((cat) => {
                  const list = dispatchListFor(cat);
                  const n = list.length;
                  return (
                    <Dropdown.Item key={cat.key} disabled={!n} onClick={() => dispatchCopy(cat.label.toLowerCase(), list)}>
                      {cat.label} <span className="text-muted">({n} course{n > 1 ? "s" : ""})</span>
                    </Dropdown.Item>
                  );
                })}
                <Dropdown.Divider/>
                <Dropdown.Header>Hors Paris ({dispatchTomorrow.length - dispatchParis.length})</Dropdown.Header>
                {dispatchProvince.length === 0 && <Dropdown.Item disabled>Aucune course</Dropdown.Item>}
                {dispatchProvince.map(({ zone, list }) => (
                  <Dropdown.Item key={zone.key} onClick={() => dispatchCopy(zone.label, list, zone.key === UNCLASSIFIED.key ? "" : zone.label.toUpperCase())}>
                    {zone.key === UNCLASSIFIED.key ? "⚠️ " : ""}{zone.label} <span className="text-muted">({list.length} course{list.length > 1 ? "s" : ""})</span>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          )}
          {verifyRight(userInfos, "booking", "create") && (
            <OutlineButtonLink
              to={`/addBooking/${
                folderId && folder && !folder.sharedBy
                  ? `?folder_id=${folderId}`
                  : ""
              }`}
            >
              <i className="la la-plus"></i>Nouvelle course
            </OutlineButtonLink>
          )}
        </div>
      </div>

      <div>
        <div className="kt-portlet--mobile">
          <div className="kt-portlet__body">
            <SelectDriverModal
              booking={selectedBooking}
              show={showSelectDriverModal}
              setShow={setShowSelectDriverModal}
              submit={updateDriverFromModal}
              fetching={isUpdatingDriver}
            />
            <FiltersModal
              show={showFiltersModal}
              setShow={setShowFiltersModal}
              filters={filters}
              setFilters={setFilters}
              userInfos={userInfos}
            />
            {folderId && (folder?.invoice_status || folder?.estimate_status) && (
              <>
                <h4>Statut du dossier</h4>
                {folder?.estimate_status && folder?.estimate_id && (
                  <div>
                    <strong>Devis:</strong>{" "}
                    <Link to={"/estimates/" + folder?.estimate_id}>
                      {folder?.estimate_id}
                    </Link>{" "}
                    ({estimateStatus[folder?.estimate_status]})
                  </div>
                )}
                {folder?.invoice_status && folder?.invoice_id && (
                  <div>
                    <strong>Facture:</strong>{" "}
                    <Link to={"/invoices/" + folder?.invoice_id}>
                      {folder?.invoice_id}
                    </Link>{" "}
                    ({invoiceStatus[folder?.invoice_status]})
                  </div>
                )}
              </>
            )}
            <div style={{overflowX: "scroll"}}>
              <table
                className="table table-striped- table-bordered table-hover table-checkable"
                id="datatable"
              >
                <thead>
                <tr>
                  <th
                    style={{width: "1%", textAlign: "center"}}
                    data-sort="false"
                  >
                    Selection
                  </th>
                  <th style={{width: "5%"}}>#</th>
                  <th style={{width: "10%"}}>Chauffeur</th>
                  <th style={{width: "4%"}}>Status</th>
                  <th style={{width: "9%"}}>Date départ</th>
                  <th style={{width: "8%"}}>Passager(s)</th>
                  <th style={{width: "8%"}}>Client</th>
                  <th style={{width: "16%"}}>Départ</th>
                  <th style={{width: "16%"}}>Destination</th>
                  <th style={{width: "8%"}}>Vehicule</th>
                  {verifyRight(userInfos, "client_price", "read") && (
                    <th style={{width: "2%"}}>Prix (client)</th>
                  )}
                  {verifyRight(userInfos, "driver_price", "read") && (
                    <th style={{width: "4%"}}>Prix (chauffeur)</th>
                  )}
                  <th style={{width: "4%"}}>Création</th>
                  <th style={{width: "4%"}}>Facturation</th>
                  <th style={{width: "3%"}}>Action</th>
                </tr>
                </thead>
                <tbody>{datatableContent}</tbody>
              </table>
            </div>
          </div>
          {folderId && FolderFooter}
          {PortletFooter}
        </div>
      </div>
    </div>
  );
}
